import { motion } from 'framer-motion';

function CookiePolicy() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="container mx-auto px-4 py-8 max-w-4xl"
    >
      <h1 className="text-3xl font-bold mb-8 bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
        Cookie Policy
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">What Are Cookies</h2>
          <p>
            Cookies are small text files that are stored on your computer or mobile device when you 
            visit our website. They help us make your experience better by:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Remembering your preferences</li>
            <li>Keeping you signed in</li>
            <li>Understanding how you use our website</li>
            <li>Improving our services based on your behavior</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Types of Cookies We Use</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold">Essential Cookies</h3>
              <p>Required for the website to function properly. Cannot be disabled.</p>
            </div>
            <div>
              <h3 className="font-semibold">Functional Cookies</h3>
              <p>Enhance your experience by remembering your preferences.</p>
            </div>
            <div>
              <h3 className="font-semibold">Analytics Cookies</h3>
              <p>Help us understand how visitors interact with our website.</p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Managing Cookies</h2>
          <p>
            Most web browsers allow you to control cookies through their settings preferences. 
            However, limiting cookies may affect your experience using our website.
          </p>
        </section>
      </div>
    </motion.div>
  );
}

export default CookiePolicy; 